import { InputBase } from './InputBase';

export class InputDropdown extends InputBase<string>{
    override controlType = 'dropdown'
    override options:{key:string, value:string}[]=[];

    constructor(options:any={}){
        super(options);
        this.options = options['options'] || []
    }
}